// extracted by mini-css-extract-plugin
export default {"pagebutton":"PageButton_pagebutton__gN72P"};